<template>
  <div class="show-map">
    <div id="addressMap" class="container"></div>
  </div>
</template>
<script  setup>
import {onMounted, defineProps, nextTick, defineEmits, ref, watch} from 'vue'
import {Position} from "@element-plus/icons-vue";
import AMapLoader from '@amap/amap-jsapi-loader';
import {ElMessage} from "element-plus";
const map = ref(null)
const marker = ref(null)
const addressObj=ref({})
const autoComplete=ref(null)
const amap = ref(null)
const infoWindow = ref(null)
const props = defineProps({
  latLng: {
    type: Object,
    default: ()=>({
      lat: '',
      lng: '',
      address:''
    })
  }
})
// 初始化自动完成
const initAutoComplete = (AMap) => {
  autoComplete.value = new AMap.AutoComplete({
    city: '全国',
    citylimit: false,
    extensions: 'all'  // 返回详细信息
  });
}
// 修改后的标记设置函数
const setMapMarker = (AMap) => {
  let address=addressObj.value.address;
  if(infoWindow.value){
    infoWindow.value.close()
  }
  // 如果标记已存在，更新位置而不是重新创建
  if (marker.value) {
    marker.value.setPosition([addressObj.value.lng, addressObj.value.lat]);
    marker.value.on('click', () => {
      if (!infoWindow.value) {
        infoWindow.value = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30),
          closeWhenClickMap: true
        })
      }
      infoWindow.value.setContent(address)
      infoWindow.value.open(map.value, marker.value.getPosition())
    })
  } else {
    // 创建新标记
    marker.value = new AMap.Marker({
      position: [addressObj.value.lng, addressObj.value.lat],
      clickable: true
    });
    // 添加标记点击事件
    marker.value.on('click', () => {
      if (!infoWindow.value) {
        infoWindow.value = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30),
          closeWhenClickMap: true
        })
      }
      infoWindow.value.setContent(address)
      infoWindow.value.open(map.value, marker.value.getPosition())
    })
    map.value.add(marker.value);
  }

  // 平滑移动地图中心
  map.value.setZoomAndCenter(16, [addressObj.value.lng, addressObj.value.lat], true);
};
watch(() => props.latLng, (newVal) => {
  addressObj.value.address=newVal.address
  addressObj.value.lat=newVal.lat
  addressObj.value.lng=newVal.lng
  if(newVal.lng && amap.value){
    setMapMarker(amap.value)
  }
},{
  immediate: true,
  deep: true,
})

/**
 * 初始化地图
 */
const initMap = async () => {
  try {
    const AMap = await AMapLoader.load({
      key: 'f6506c4fc4b00c2e357ec7748871d61a', // 替换为您申请的key
      version: '2.0',
      plugins: ['AMap.Geolocation','AMap.Geocoder','AMap.AutoComplete','AMap.InfoWindow']
    })

    amap.value = AMap  // 保存 AMap 实例

    // 创建地图实例
    map.value = new AMap.Map('addressMap', {
      zoom: 15,
      center: [116.397428, 39.90923]
    })
    initAutoComplete(AMap);
  } catch (e) {
    console.error('地图加载失败：', e)
  }
}
onMounted(() => {
  nextTick(() => {
    initMap()
  })
})
</script>
<style lang="scss" scoped>
.show-map {
  width: 100%;
  height: 100%;
  position: relative;
  .container {
    z-index: 2;
    width: 100%;
    height: 100%;
    min-height: 433px;
    position: relative;

    :deep(.logo-text) {
      display: none;
    }

    :deep(a) {
      display: none;
    }
  }
}

</style>

